import { render } from "./Couplepunks.vue?vue&type=template&id=0a750bf0&scoped=true"
import script from "./Couplepunks.vue?vue&type=script&lang=js"
export * from "./Couplepunks.vue?vue&type=script&lang=js"

import "./Couplepunks.vue?vue&type=style&index=0&id=0a750bf0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a750bf0"

export default script